'use strict';

angular.module('webAgro1App').directive('plantio', function(InformacoesCultivaresService) {
  return {
    templateUrl: 'views/directives/data_plantio_template.html',
    restrict: 'AE',
    scope: {
      safra: '=',
      gleba: '=',
      insumo: '='
    },
    link: function (scope) {
      scope.$watchGroup(['safra', 'gleba', 'insumo'], function(newValues, oldValues, scope) {
        scope.plantio = {};
        if (scope.safra && scope.gleba && scope.insumo) {
          scope.plantio = {
            loading: true
          };
          var params = {
            safra: scope.safra,
            gleba: scope.gleba,
            insumo: scope.insumo
          };

          InformacoesCultivaresService.getDataPlantio(params).then(function(result) {
            scope.plantio.dataPlantio = result.data.data_plantio;
          }).finally(function() {
            scope.plantio.loading = false;
          });
        }
      });
    }
  };
});
